
<template>

    <v-flex xs12 sm10 offset-sm1 md8 offset-md2 lg6 offset-lg3>

        <v-container text-xs-center>

           <v-chip class="ma-2" color="primary" text-color="white">
                {{ $t( 'miniGame.token' ) }} :  {{ member.token }}
            </v-chip>

            <v-chip class="ma-2" color="green" text-color="white">
                {{ $t( 'miniGame.credit' ) }} : {{ member.credit }}
            </v-chip>

            <v-container grid-list-md>

                <v-layout row wrap>

                    <v-flex xs6 sm6 md6>

                        <v-menu :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">

                            <template v-slot:activator="{ on }">

                                <v-text-field v-model="filterData.fromDate" :label="$t( 'history.date_from' )" prepend-icon="event" readonly v-on="on"></v-text-field>

                            </template>

                            <v-date-picker v-model="filterData.fromDate"></v-date-picker>

                        </v-menu>

                    </v-flex>

                    <v-flex xs6 lg6>

                        <v-menu :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">

                            <template v-slot:activator="{ on }">

                                <v-text-field v-model="filterData.toDate" :label="$t( 'history.date_to' )" prepend-icon="event" readonly v-on="on"></v-text-field>

                            </template>

                            <v-date-picker v-model="filterData.toDate"></v-date-picker>

                        </v-menu>

                    </v-flex>

                </v-layout>

                <!-- <v-layout row wrap>
                    <v-flex xs6 sm6 md6>
                        <v-text-field class="v-text-field" v-model="filterData.fromId" :label="$t( 'miniGame.fromId' )"></v-text-field>
                    </v-flex>
                    <v-flex xs6 lg6>
                        <v-text-field class="v-text-field" v-model="filterData.toId" :label="$t( 'miniGame.toId' )"></v-text-field>
                    </v-flex>
                </v-layout> -->
                <!-- <v-text-field class="v-text-field" v-model="filterData.name" :label="$t( 'miniGame.prizeName' )" required></v-text-field> -->
                <!-- <v-layout row>
                    <v-select :items="filterCategory" :label="$t( 'miniGame.category' )" v-model="filterData.category" item-text="name" item-value="value">
                    </v-select>
                </v-layout>
                <v-layout row>
                    <v-select :items="filterStatus" :label="$t( 'miniGame.status' )" v-model="filterData.status" item-text="name" item-value="value">
                    </v-select>
                </v-layout> -->

                <v-flex xs12 lg>

                    <v-btn small color="success" @click.prevent="getMiniGamePrizesList">
                        {{ $t( 'shared.search' )  }}
                    </v-btn>

                    <v-btn small color="error" @click.prevent="resetDate">
                        {{ $t( 'shared.reset' )  }}
                    </v-btn>

                </v-flex>

                <TicketDialog :dialog="showTicketDetailDialog" :detail="dialogTicketDetail" @close-dialog="closeTicketDetail" />

                <BonusDialog :dialog="showBonusFormDialog" :selectedPrize="dialogBonusForm" @close-dialog="closeBonusForm" @save-dialog="showSnackbar"/>

                <MiniGamePrizeDialog :dialog="showPrizeDetailDialog" :detail="dialogPrizeDetail" @close-dialog="closePrizeDetail"/>

            </v-container>

            <v-divider></v-divider>

            <!--Table-->
            <v-data-table
                v-if="rows != null"
                :headers="headers"
                :items="rows"
                class="elevation-1 mt-2"
                :pagination.sync="pagination"
                :total-items="pagination.totalItems"
                :rows-per-page-items="rowsPerPageItems"
                :rows-per-page-text="rowsPerPageItemsText"
                :loading="isLoading">

                <v-progress-linear v-slot:progress color="blue" :indeterminate="true"></v-progress-linear>

                <template v-slot:items="props">

                    <tr>

                        <td class="text-xs-center">{{ props.item.id }}</td>

                        <td class="text-xs-center">{{ props.item.gameName }}</td>

                        <td class="text-xs-center">{{ props.item.name }}</td>

                        <td class="text-xs-right">{{ props.item.amount.toFixed(2) }}</td>

                        <td class="text-xs-center">

                            <span v-if="props.item.status == 'Claim'" class="text-success">

                                {{ $t( 'miniGame.claim' ).toUpperCase() }}

                            </span>

                            <span v-else-if="props.item.status == 'Unclaim'">

                                <span v-if="props.item.category == 'Credit'">

                                    <span v-if="props.item.ticket_id">

                                        {{ $t( 'history.processing' ) }}

                                    </span>

                                    <span v-else-if="props.item.claimable_days > 0">

                                        <v-btn tile outlined small color="primary"  @click="showBonusForm(props.item)">

                                            <v-icon small left>fas fa-gift</v-icon> {{ $t( 'miniGame.unclaim' ).toUpperCase() }}

                                        </v-btn>

                                    </span>

                                    <span v-else class="text-danger">

                                        {{ $t( 'miniGame.unclaim' ).toUpperCase() }}

                                    </span>

                                </span>

                                <span v-else class="text-danger">

                                    {{ $t( 'miniGame.unclaim' ).toUpperCase() }}

                                </span>

                            </span>

                            <span v-else></span>

                        </td>

                        <td class="text-xs-center" v-html="getClaimableText(props.item)"></td>

                        <td class="text-xs-center">

                            <v-btn small outline @click="showPrizeDetail(props.item)">
                                <span>{{ $t( 'history.detail' )  }}</span>
                            </v-btn>

                            <v-btn v-if="props.item.ticket_id" small outline @click="showTicketDetail(props.item)">
                                <span>{{ $t( 'history.bonus' )  }}</span>
                            </v-btn>

                        </td>

                    </tr>

                </template>

            </v-data-table>

        </v-container>

        <!--Snackbar-->
        <Snackbar :show="snackbar" :color="color" :text="message" :icon="'done_all'" :timeout="2000"/>

    </v-flex>

</template>

<script>
import Api from "@/api";
import Snackbar from "@/components/Reusable/Snackbar.vue";
import TicketDialog from "@/components/Reusable/TicketDialog.vue";
import BonusDialog from "@/components/Bonus/BonusDialog.vue";
import MiniGamePrizeDialog from "@/components/MiniGame/MiniGamePrizeDialog.vue";

export default {
    name: 'MiniGamePrizes',
    components: {
        TicketDialog,
        BonusDialog,
        MiniGamePrizeDialog,
        Snackbar
    },
    data() {
        return {
            member: {
                token: 0,
                credit: 0
            },
            pagination: {
                rowsPerPage: 10,
                totalItems: 0,
                page: 1
            },
            rowsPerPageItems: [10],
            rowsPerPageItemsText: "10",
            rows: [],
            isLoading: false,
            showTicketDetailDialog: false,
            dialogTicketDetail: {},
            showBonusFormDialog: false,
            dialogBonusForm: {},
            showPrizeDetailDialog: false,
            dialogPrizeDetail: {},
            filterData:{
                category: '',
                status: '',
                name: '',
                fromDate: '',
                toDate: '',
                fromId: '',
                toId: ''
            },
            snackbar: false,
            message: "",
            color: ""
        }
    },
    mounted() {

        this.getMiniGameProfile();

        this.getMiniGamePrizesList();

    },
    methods: {
        showSnackbar(response) {

            this.message = response.message;

            if (this.message == "Submit Ticket Successfully") {

                this.message = this.$t( 'deposit.submit_ticket_success' );

                this.getMiniGamePrizesList();
            }

            this.color = "green";

            this.showBonusFormDialog = response.dialog;

            this.snackbar = true;

        },
        getMiniGameProfile: async function() {

            // prepare api data
            let params = {
                access_token: this.$store.getters.user_token
            };

            let res = await Api.getMemberMiniGameProfile(params);

            if (res && 'success' in res && res.success === true) {

                this.member.token = res.data[0].token;

                this.member.credit = res.data[0].credit;

            } else {
                if(res.message == "token invalid") {

                    this.$store.dispatch('logout', res.data);

                    this.$router.push({name: 'login'})
                }
            }
        },
        getMiniGamePrizesList: async function() {

            this.isLoading = true;

            // prepare api data
            let params = {
                access_token: this.$store.getters.user_token,
                paginate: this.pagination.rowsPerPage,
                page: this.pagination.page
            };

            if(this.filterData.fromDate) {

                params.startDate = this.filterData.fromDate + ' 00:00:00';
            }

            if(this.filterData.toDate) {

                params.endDate = this.filterData.toDate + ' 23:59:59';
            }

            if(this.filterData.fromId) {

                params.idFrom = this.filterData.fromId;
            }

            if(this.filterData.toId) {

                params.idTo = this.filterData.toId;
            }

            if(this.filterData.category) {

                params.category = this.filterData.category;
            }

            if(this.filterData.status) {

                params.status = this.filterData.status;
            }

            if(this.filterData.name) {

                params.name = this.filterData.name;
            }

            let res = await Api.getMemberMiniGamePrizesList(params);

            if (res && 'success' in res && res.success === true) {

                this.rows = res.data.prizeLogs;

                this.pagination.rowsPerPage = res.data.pagination.per_page;

                this.pagination.totalItems = res.data.pagination.total;

            } else {

                if(res.message == "token invalid") {

                    this.$store.dispatch('logout', res.data);

                    this.$router.push({name: 'login'})

                }

            }

            this.isLoading = false;

        },
        resetDate: function() {

            this.filterData.toDate = "";

            this.filterData.fromDate = "";

        },
        showTicketDetail: function(obj) {

            if(obj.ticket_id) {

                this.showTicketDetailDialog = true;

                this.dialogTicketDetail = [obj.ticket];

            }

        },
        closeTicketDetail: function() {

            this.showTicketDetailDialog = false;

        },
        showPrizeDetail: function(obj) {

            this.showPrizeDetailDialog = true;

            this.dialogPrizeDetail = [obj];

        },
        closePrizeDetail: function() {

            this.showPrizeDetailDialog = false;

        },
        showBonusForm: function(obj) {

            this.showBonusFormDialog = true;

            this.dialogBonusForm = obj;

        },
        closeBonusForm: function() {

            this.showBonusFormDialog = false;

        },
        getStatusText: function(status) {

            if (status == 'Unclaim') {

                return this.$t( 'miniGame.unclaim' );

            } else if (status == 'Claim') {

                return this.$t( 'miniGame.claim' );

            }

            return status;
        },
        getClaimableText: function(prize) {

            if(prize.status == 'Claim') {

                return this.$t( 'miniGame.claim' );

            } else {

                if(prize.claimable_days == '') {

                    return '-';

                } else {

                    if(prize.claimable_days > 0) {

                        return prize.claimable_days;

                    } else {

                        return  this.$t( 'miniGame.expired');

                    }

                }

            }

        }

    },
    computed: {
        headers() {
            return [
                {
                    text: this.$t( 'miniGame.id' ),
                    align: 'center',
                    sortable: false,
                    value: 'id'
                },
                {
                    text: this.$t( 'miniGame.game' ),
                    align: 'center',
                    sortable: false,
                    value: 'gameName'
                },
                {
                    text: this.$t( 'miniGame.prizeName' ),
                    align: 'center',
                    sortable: false,
                    value: 'name'
                },
                {
                    text: this.$t( 'miniGame.amount' ),
                    align: 'right',
                    sortable: false,
                    value: 'amount'
                },
                {
                    text: this.$t( 'miniGame.status' ),
                    align: 'center',
                    sortable: false,
                    value: 'status',
                    width: '200px'
                },
                {
                    text: this.$t( 'miniGame.claimable_days' ),
                    align: 'center',
                    sortable: false,
                    value: 'claimable_days',
                    width: '200px'
                },
                {
                    text: this.$t( 'history.detail' ),
                    align: 'center',
                    sortable: false,
                    value: 'detail'
                }
            ]
        },
        filterCategory() {

            return  [
                {
                    name: this.$t( 'miniGame.all' ),
                    value:''
                },
                {
                    name: this.$t( 'miniGame.credit' ),
                    value:'Credit'
                },
                {
                    name: this.$t( 'miniGame.cash' ),
                    value:'Cash'
                },
                {
                    name: this.$t( 'miniGame.gift' ),
                    value:'Gift'
                },
            ];
        },
        filterStatus() {

            return  [
                {
                    name: this.$t( 'miniGame.all' ),
                    value:''
                },
                {
                    name: this.$t( 'miniGame.unclaim' ),
                    value:'Unclaim'
                },
                {
                    name: this.$t( 'miniGame.claim' ),
                    value:'Claim'
                },
            ];
        }
    },
    watch: {
        pagination: {
            async handler () {
                await this.getMiniGamePrizesList();
            },
            deep: true
        },
        message: function(message) {

            if(message) {

                let currentInstance = this;

                setTimeout(function() {

                    currentInstance.snackbar = false;

                    currentInstance.message = '';

                } , 2000);

            }

        }

    },

}
</script>

<style scoped>
    .v-datatable hr {
        margin-top: 0;
        margin-bottom: 0;
        border-top: 1px solid rgba(210, 210, 210, 0.35);
    }
</style>


